import type { Sport } from "@/hooks/firestore/models/sports";

import { useRemoteConfig } from "@/hooks/remoteConfig/useRemoteConfig";
import { attempt } from "@/utilities/attempt";

export const useTrackerEnabledSports = () => {
  const { loading, value } = useRemoteConfig("bet_tracker_sports");

  const stringVal = value?.asString() ?? "{}";
  const result = attempt(() => JSON.parse(stringVal));
  const enabledSports: Record<Sport, boolean> = result.ok ? result.data : {};

  return { loading, enabledSports };
};
